import React from 'react'

import classNames from 'classnames'

interface BodyProps {
  children?: React.ReactNode
  text?: string
  className?: string
}

export const Body: React.FC<BodyProps> = ({ children, text, className }) => {
  return (
    <div className={classNames('o-modal-body', className)}>
      {children ?? (text ? <h4>{text}</h4> : null)}
    </div>
  )
}
